import PageTitle from 'components/PageTitle';
import Section from 'components/Section';
import { InlineClippedImage } from 'components/InlineClippedImage';

import Connell_2008_Ponder from 'assets/images/content/Connell_2008_Ponder.jpg';
import Connell_2010_Findings from 'assets/images/content/Connell_2010_Findings.jpg';
import reflections from 'assets/images/content/Connell_2008_Reflection.jpg';

import Arrow from 'assets/Arrow.svg';

const Home = () => {
	return (
		<>
			<PageTitle title="Home" />
			<div className="container px-4 mx-auto mt-12 md:mt-24 sm:px-6">
				<div className="grid grid-cols-1 gap-6 lg:grid-cols-[40%_1fr]">
					<div className="max-w-[501px] w-full lg:ml-auto">
						<h2 className="font-trade-compressed uppercase m-0 text-2xl sm:text-3xl md:text-[2.5rem] font-bold tracking-widest">About Progressive</h2>
					</div>
					<div className="max-w-[740px] w-full">
						<p className="font-late-serif text-[1.375rem] md:text-[1.65rem] leading-[1.6] mb-6">The Progressive Group of Insurance Companies, in business since 1937, is one of the country&apos;s largest auto insurance groups, the largest seller of motorcycle and boat policies, the market leader in commercial auto insurance, and one of the top 15 homeowners carriers, based on premiums written.</p>
						<p>Progressive is committed to becoming consumers&apos;, agents&apos;, and business owners&apos; number one destination for insurance and other financial needs by providing competitive rates and innovative products and services that meet customers&apos; needs throughout their lifetimes, including superior mobile, online, and in-person customer service, and best-in-class, 24-hour claims service.</p>
						<p>Progressive companies offer consumers choices in how to shop for, buy, and manage their insurance policies. Progressive primarily offers personal and commercial auto insurance, insurance for motorcycles, watercraft, and other recreational vehicles, and personal residential property insurance. We also offer business-related general liability and commercial property insurance predominantly for small businesses, workers&apos; compensation insurance primarily for the transportation industry, and other specialty property-casualty insurance. We operate our Personal and Commercial Lines businesses through more than 40,000 independent insurance agencies throughout the U.S. and directly to consumers online, or by phone, and, for personal auto, via the Progressive mobile app. Our homeowners business is underwritten by Progressive companies, and other select carriers, throughout the United States.</p>
					</div>
				</div>
			</div>
			<div className="container px-4 py-12 mx-auto sm:px-6 sm:py-24">
				<div className="relative max-w-[994px] aspect-[4/3]">
					<InlineClippedImage
						src={reflections}
						alt=""
						dimensions={{
							width: 1920,
							height: 1440,
						}}
						className="max-w-[452px] w-full m-0 ml-auto"
						clipPaths={[
							{
								initial: { x: '0%', y: '0%', width: '40%' },
								expanded: { x: '0%', y: '0%', width: '100%' },
							},
						]}
					/>
				</div>
			</div>
			<Section backgroundColor="#4B7B9D" textColor="#fff">
				<div className="container px-4 mx-auto mt-0 mb-12 md:my-12 sm:px-6">
					<div className="grid grid-cols-1 lg:grid-cols-[40%_1fr] gap-6 lg:gap-12">
						<div className="lg:ml-auto lg:max-w-[501px]">
							<h2 className="font-trade-compressed uppercase m-0 font-bold text-2xl sm:text-3xl md:text-[2.5rem] mb-6 tracking-widest">EMPATHY</h2>
							<p>
								Me. You. <strong>We.</strong> To be able to view the world and people within it through the lens of understanding and with genuine concern, we must first be able to recognize our true selves and reflect on the differences within us. At Progressive, our Core Values define who we are, and serve as the foundation for how we interact with others. Within the physical and virtual halls of Progressive, we have an incredible opportunity to live the Golden Rule every day. By putting ourselves in the shoes of our customers, showing compassion for those struggling in our communities, and taking the time to understand the partners we serve, we can help them move forward and live fully. With this purpose at the center of why we are here, we chose “empathy” as the theme for this year’s annual report.
							</p>
							<p>
								American photographer Kelli Connell’s <em>Double Life</em> series is a complex body of work documenting dual portraits of a single model over twenty-two years. These portraits poetically reveal one’s interior life of contrasting wants, identities, and internal monologues by elevating the mundane or familiar. The “double life” suggested in these photographs is that we can also interpret the figures as two different people in equally complex and emotionally significant moments. Ultimately, these artworks illustrate not only how we show empathy towards those around us, but also how we care for, argue with, forgive, and love who we are individually. A selection of these photographs will join Progressive’s growing collection of contemporary art.
							</p>
						</div>
						<div className="grid gap-6">
							<div className="my-auto mx-auto lg:max-w-[630px] w-full">
								<div className="grid gap-8 lg:gap-0">
									<div className="max-w-[452px] aspect-[452/339] w-full m-0 lg:ml-auto">
										{/* <Floating sensitivity={0.5}>
											<FloatingElement depth={1.5}> */}
										<InlineClippedImage
											src={Connell_2008_Ponder}
											alt=""
											dimensions={{
												width: 1920,
												height: 1440,
											}}
											className="max-w-[452px] w-full m-0 ml-auto"
											clipPaths={[
												{
													initial: {
														x: '51%',
														y: '22%',
														width: '18%',
													},
													expanded: {
														x: '0%',
														y: '0%',
														width: '100%',
													},
												},
											]}
										/>
										{/* </FloatingElement>
										</Floating> */}
									</div>
									<div className="max-w-[452px] aspect-[452/339] w-full lg:mt-[-47px]">
										{/* <Floating sensitivity={0.5}>
											<FloatingElement depth={1.25}> */}
										<InlineClippedImage
											src={Connell_2010_Findings}
											alt=""
											dimensions={{
												width: 1920,
												height: 1440,
											}}
											clipPaths={[
												{
													initial: {
														x: '38%',
														y: '9%',
														width: '30%',
													},
													expanded: {
														x: '0%',
														y: '0%',
														width: '100%',
													},
												},
											]}
										/>
										{/* </FloatingElement>
										</Floating> */}
									</div>
								</div>
							</div>
							<div className="grid mt-auto mx-auto max-w-[630px]">
								<div className="ml-auto">
									<a href="https://www.progressive.com/about/art/" target="_blank" rel="noreferrer" className="text-[1.5625rem] no-underline flex items-center gap-6">
										The Progressive Art Collection
										<span className="h-[38px] w-[38px] bg-[#C9B815] flex items-center justify-center">
											<img src={Arrow} className="max-w-[17px]" />
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Section>
		</>
	);
};

export default Home;
